import { StaggeredAnimation } from "#components/animation/StaggeredAnimation.tsx";
import { StaggeredAnimationItem } from "#components/animation/StaggeredAnimationItem.tsx";
import { getSourceKey } from "#features/citations/citedContent.ts";
import { SOURCES_MAX_STAGGER_DELAY, SourcesSidePanelCard } from "#features/conversations/components/sources-side-panel/SourcesSidePanelCard.tsx";
import { useSourcesSidePanelStore } from "#features/conversations/stores/useSourcesSidePanelStore.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import { Content, Heading, Modal } from "@hopper-ui/components";
import { useCallback } from "react";
import { useShallow } from "zustand/shallow";
import "./SourcesModal.css";

export const SourcesModal = () => {
    const { tShared } = useSharedTranslation();
    const isSidePanelOpen = useSidePanelStore(state => state.isSidePanelOpen);
    const { closeMessageSources, activeMessage, activeCitations } = useSourcesSidePanelStore(useShallow(state => ({
        closeMessageSources: state.closeMessageSources,
        activeMessage: state.activeMessage,
        activeCitations: state.activeCitations
    })));

    const handleOpenChange = useCallback((isOpen: boolean) => {
        if (!isOpen) {
            closeMessageSources();
        }
    }, [closeMessageSources]);

    if (!activeMessage) {
        return null;
    }

    return (
        <Modal
            size="sm"
            isOpen={isSidePanelOpen}
            onOpenChange={handleOpenChange}
            className="wai-sidepanel-as-modal wai-sources-modal wai-scrollbars"
            data-private
        >
            <Heading
                marginLeft="core_160"
                marginBottom="core_240"
                size="md"
            >
                {tShared("sourcesCount", { count: activeCitations.length })}
            </Heading>
            <Content
                borderTop="neutral-weak"
                margin="core_0"
                minHeight="core_1280"
            >
                <StaggeredAnimation maxDelay={SOURCES_MAX_STAGGER_DELAY}>
                    {activeCitations.map(citation => (
                        <StaggeredAnimationItem key={getSourceKey(citation.source)}>
                            <SourcesSidePanelCard citation={citation} />
                        </StaggeredAnimationItem>
                    ))}
                </StaggeredAnimation>
            </Content>
        </Modal>
    );
};
